//ngControllers.controller('', ['this','panel', 'FileUploader', function(this, panel, FileUploader)
import FeatureController from '../FeatureController';

export default class ProfileController extends FeatureController{

    constructor(panel, FileUploader, $state)
    {
        super(panel, $state);
        const self = this;
        this.init_uploader(FileUploader);

        this.age_range = this.panel.range(17, 100);

        this.bodies = [];

        window.addEventListener('popstate', function() {
            self.set_view();
        });
        let username = $state.params.username ? $state.params.username : this.panel.getUser().screen_name;
        this.accessViolation = false;
        this.settingsPage = false;
        if ($state.params.settings) {
            this.settingsPage = true;
            if (username !== this.panel.getUser().screen_name) {
                this.accessViolation = true;
               return;
            }
        }

        if (!this.settingsPage) {
            this.panel.get('/v1/profile/' + username, (response) => {
                if (self.panel.okay(response)) {
                    for (let i in response) {
                        if (i !== 'data') {
                            self[i] = response[i];
                        } else {
                            for (let j in response.data) {
                                self[j] = response.data[j];
                            }
                        }
                    }
                    self.set_view();
                }
            });
        } else {
            this.panel.get('/v1/profile/' + username+'?p=settings', (response) => {
                if (self.panel.okay(response)) {
                    self.config = response.data.config;
                    self.register = response.data.register;
                }
            });

            this.settings = {

                init() {
                    self.auth = {};
                    self.config.notifications = $.parseJSON(self.config.notifications);
                },

                set_notification: function (e, item) {
                    item.val = $(e.target).prop('checked') ? 1 : 0;
                },

                toggle_password: () => {

                    let eye = $('.fa-eye');
                    self.password_eye_title = eye.attr('title');

                    (
                        !eye.hasClass('toggle') &&
                        eye.addClass('toggle') &&
                        eye.attr('title', 'Hide password').css({color: '#D15770'}) &&
                        $('#reset-pass').attr('type', 'text'))
                    || (
                        eye.removeClass('toggle') &&
                        eye.attr('title', self.password_eye_title).css({color: '#6C6D83'}) &&
                        $('#reset-pass').attr('type', 'password')
                    );
                },

                save() {

                    self.panel.post('/v1/update/settings', {
                        register: self.register,
                        auth: self.auth,
                        config: self.config
                    }, (response) => {

                        if (self.panel.okay(response)) {
                            self.panel.dashboard_message("Your settings have been successfully saved.");
                        } else {
                            self.panel.dashboard_error(response.message);
                        }
                    });
                },

                delete_account() {
                    self.panel.confirm("Are you sure you want to delete your account." +
                        "Note it will take up to 6 weeks for your account to be completely removed", () => {
                        self.panel.confirm("<p><strong>Please enter your password</strong></p><input class='form-control D_ACC' type='password'/>", () => {

                            self.panel.post('/v1/update/delete_account', {password: $('.D_ACC').val()}, (response) => {

                                if (self.panel.okay(response)) {
                                    self.panel.account_deleted_redirect();
                                } else {
                                    self.panel.dashboard_error(response.message);
                                }
                            });
                        }, "Delete My Account", {yes: 'Delete', no: 'Cancel'});
                    }, "Warning", {yes: 'Continue', no: 'Cancel'});
                },

            };
        }
    }


    set_view (view){

        $('.nav li a').removeClass('selected'); $('.profile_view').hide();

        if(typeof view == 'undefined'){

            view = location.hash.substring(1);
            view = view.indexOf('#') > -1 ? view.substring(view.indexOf('#')+1) : view;
            view = view.indexOf('-') > -1 ? view.substring(0, view.indexOf('-')) : view;

            if(view.length == 0){view = 'intro';}
        }
        let _vclass  = '.'+view+'-link';
        $(document).ready(()=>{
            $(_vclass).addClass('selected'); $('.'+view).show();
        });
    }

    click_uploader () {
        this.uploader.clearQueue();
        $("#uploader").click();
    }

    init_gallery (){

        if(typeof location.hash != 'undefined'){

            let photo_id = location.hash.substring(1);

            for(i in this.images){

                if(this.images[i]['parent_id'] == photo_id){

                    this.current_photo = this.images[i]; break;
                }
            }
        }
    }

    add_caption (photo){
        let caption = photo.caption == null ? '' : photo.caption;
        this.panel.confirm("<textarea style='width:300px;height:55px;text-align:left;padding:5px;' id='add_caption'>"+caption+"</textarea>", () => {

            let caption = $("#add_caption").val();

            let data = {q:'add_caption', a:{id:photo.parent_id, caption:caption}};

            const self = this;

            this.panel.post('/v1/profile?p=actions', data, (response) => {

                if(self.panel.okay(response)){

                    photo.caption = caption;

                    self.panel.alert("Your caption has been saved.");
                }
            });
        }, "Add Image Caption", {yes:'Add Caption', no:'Cancel'});
    }

    set_profile_photo (photo){

        const self = this;

        this.panel.post('/v1/profile?p=actions', {q:'set_profile_photo', a:{id:photo.id}}, (response) => {

            if(self.panel.okay(response)){

                for(i in self.images){

                    if(self.images[i]['id'] == photo.id){

                        self.images[i]['image_id'] = photo.id;

                        $(".global-profile-photo").attr('src', self.image_url+self.images[i]['name']);
                    }
                    else{

                        self.images[i]['image_id'] = null;
                    }
                }
            }
        })
    }

    delete_photo (photo) {

        const self = this;

        this.panel.post('/v1/profile?p=actions', {q:'delete_photo', a:{photo:angular.toJson(photo)}}, (response) => {

            if(self.panel.okay(response)){

                let i = self.images.indexOf(photo);

                self.images.splice(i, 1);
            }
        });
    };

    is_profile_pic (photo) {

        return photo.image_id != null;
    }

    toggle_view (hide, show) {

        $('.'+hide).addClass('hide');

        $('.'+show).removeClass('hide');
    }

    edit (edit) {
        $('.profile-popup-edit-'+edit).removeClass('hide');
    }

    popup_close (edit) {
        $('.profile-popup-edit-'+edit).addClass('hide');
    }

    update_profile (){

        let birthday = $("#birthday").val();

        if(birthday != ''){

            let year = new Date().getFullYear();

            let birth_year = parseInt(birthday.substring(0,4));

            if(year - birth_year < 17){

                this.panel.alert("Invalid age. You must be at least +17 years old.");

                return;
            }

            this.profile.birthday = birthday;
        }

        let data = {profile:this.profile};

        const self = this;

        this.panel.post('/v1/update/profile', data, (response) => {

            $('.popup-cancel').click();

            if(self.panel.okay(response)){

                self.panel.alert("Your changes have been saved!");
                window.location = '/profile#intro';
                self.set_view();
            }
        });
    }

    update_match (){

        for(let i in this.match){

            if(this.match[i] != null){

                if(this.match[i].constructor === Array){

                    this.match[i] = this.match[i].join(',');
                }
            }
        }

        let data = {match:this.match};

        const self = this;

        this.panel.post('/v1/update/match', data, (response) => {

            $('.popup-cancel').click();

            if(self.panel.okay(response)){

                self.panel.alert("Your ideal match has been saved!");
                window.location = '/profile#match';
                self.set_view();
            }
        });
    }


    update_settings (){

    };

    init_uploader(FileUploader) {
      const self = this;

      this.uploader = new FileUploader({
        autoUpload: false,
        url: self.panel.getBaseUrl()+'/uploader',
        queueLimit: 12,
        removeAfterUpload: true,
        headers: self.panel.getRequestHeaders()
      });

      this.uploader.onAfterAddingFile = function(item) {
        item.croppedImage = '';
        let reader = new FileReader();
        reader.onload = function(event) {
            item.image = event.target.result;
        };
        reader.readAsDataURL(item._file);
        item.formData = new FormData();
      };

      this.uploader.onBeforeUploadItem ((item) => {
        let dataURItoBlob = function(dataURI) {
          let binary = atob(dataURI.split(',')[1]);
          let mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
          let array = [];
          for(let i = 0; i < binary.length; i++) {
            array.push(binary.charCodeAt(i));
          }
          return new Blob([new Uint8Array(array)], {type: mimeString});
        };
        item._file = dataURItoBlob(item.croppedImage);
        console.log(item);
      });

      this.uploader.onSuccessItem ((item, response)=>{
        if(self.panel.okay(response)){
          self.images.push(response.image);
        }
      });
    }

    getWidth () {
        return $('#cropping-space').width();
    }
}



// WEBPACK FOOTER //
// ./src/app/features/profile/ProfileController.js